import React from 'react'

interface DiamondIconProps {
  color: string
  size?: number
  borderColor?: string
  borderWidth?: number
  borderRadius?: number
}

const DiamondIcon: React.FC<DiamondIconProps> = ({
  color,
  size = 50,
  borderColor,
  borderWidth = 0,
  borderRadius = 14
}) => (
  // Rect side = 100 / √2 ≈ 70.71 so the diamond's rotated bounding box fills the full
  // 100x100 viewBox. This makes the visible diamond ≈ `size`, matching how antd icons
  // render at `fontSize: size`, so callers can use one consistent `size` value.
  <svg width={size} height={size} viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="14.645"
      y="14.645"
      width="70.71"
      height="70.71"
      fill={color}
      transform="rotate(45 50 50)"
      rx={borderRadius}
      stroke={borderColor}
      strokeWidth={borderWidth}
    />
  </svg>
)

export default DiamondIcon
